import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Alert, Button, TextField, Typography } from "@mui/material";
import { runSandboxSecurityChecks } from "../api/sandbox-security";
import { paymentError } from "../api/payments";

export default function SandboxSecurity() {
  const { token, userId } = useSelector((state) => state.user);
  const [reference, setReference] = useState(""), [result, setResult] = useState(null), [busy, setBusy] = useState(false), [error, setError] = useState("");
  const pending = useRef(false);
  async function run() {
    if (pending.current || result) return;
    pending.current = true; setBusy(true); setError("");
    try { setResult(await runSandboxSecurityChecks(token, userId, crypto.randomUUID(), reference.trim())); }
    catch (reason) { setError(reason.message.startsWith("sandbox-") ? "آزمون فقط برای تنظیمات و سفارش TEST مجاز است." : paymentError(reason)); }
    finally { pending.current = false; setBusy(false); }
  }
  return <section className="mt-6">
    <Typography variant="h6">آزمون محدود امنیت و هم‌زمانی در تست</Typography>
    <Alert severity="info" className="my-3">این آزمون چند سفارش TEST علامت‌گذاری‌شده می‌سازد، حداکثر دو درخواست هم‌زمان ارسال می‌کند و با ذخیرهٔ همان تنظیمات موجود، تعارض نسخه را می‌آزماید. آزمون بار یا حمله به سرویس درگاه انجام نمی‌شود.</Alert>
    <TextField fullWidth label="سفارش تست یک یورویی مرجع برای آزمون بازپرداخت نامعتبر" value={reference} disabled={busy || Boolean(result)} onChange={(event) => setReference(event.target.value)} inputProps={{ dir: "ltr" }} />
    <Button className="my-3" variant="outlined" disabled={busy || Boolean(result)} onClick={run}>{busy ? "در حال بررسی…" : "اجرای بررسی کنترل‌شده امنیت و هم‌زمانی"}</Button>
    {error && <Alert severity="error">{error}</Alert>}
    {result && <div><p>سفارش آزمون: <span dir="ltr">{result.orderId}</span></p><ul>{result.results.map((row) => <li key={row.name} className="my-2">{row.passed ? "✓" : "✗"} {row.name}: <span dir="ltr">{row.detail}</span></li>)}</ul></div>}
  </section>;
}
